import React from 'react';
import { Section, Container } from '../styles/shared';
import { rewriteMediaServeUrls } from '../utils/mediaServeUrls';

const sanitize = (html) => html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');

const HTMLBlock = ({ content = {}, settings = {}, tenantSlug = '', apiBase = '/api/v1' }) => {
  const { html = '', containerId = '', containerClass = '' } = content;
  const { backgroundColor = '', padding = 'medium' } = settings;
  if (!html) return null;
  const renderedHtml = rewriteMediaServeUrls(sanitize(html), tenantSlug, apiBase);
  return (
    <Section $padding={padding} $bgColor={backgroundColor}>
      <Container>
        <div id={containerId || undefined} className={containerClass || undefined}
          dangerouslySetInnerHTML={{ __html: renderedHtml }} />
      </Container>
    </Section>
  );
};

export default HTMLBlock;
